import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {api} from '../helpers/api';
import utils from '../helpers/utils';

export const NORTON_SOS_REQUEST = 'NORTON_SOS_REQUEST';
export const NORTON_SOS_SUCCESS = 'NORTON_SOS_SUCCESS';
export const NORTON_SOS_FAILURE = 'NORTON_SOS_FAILURE';

function nortonSOSRequest() {
  return {
    type: NORTON_SOS_REQUEST,
  };
}

function nortonSOSSuccess(payload: $TSFixMe) {
  const isSuccess = _get(payload, 'success');

  if (!isSuccess) {
    return {
      type: NORTON_SOS_FAILURE,
      error: 'Error',
    };
  }

  Object.assign(payload, {isFetching: false});

  return {
    type: NORTON_SOS_SUCCESS,
    nortonSOS: payload || null,
  };
}

function nortonSOSFailure(error: $TSFixMe) {
  return {
    type: NORTON_SOS_FAILURE,
    error,
  };
}

export function getNortonSOS(nortonState: $TSFixMe, accountId: $TSFixMe) {
  if (!_isEmpty(nortonState)) {
    if (nortonState.isFetching) {
      return null;
    }
  }

  const url = utils.getNortonSOSPath();

  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      account_id: accountId,
    },
    credentials: 'include',
  };

  return api(url, config, nortonSOSRequest(), nortonSOSSuccess, nortonSOSFailure);
}
